import * as Yup from 'yup';

export const WorkshopApplySchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Name is too short! Min characters: 2')
    .max(50, 'Name is too long! Max characters: 50')
    .required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
  phone: Yup.string()
    .min(10, 'Must be 10 digits. Eg. 9967025257')
    .max(10, 'Must be 10 digits. Eg. 9967025257')
    .matches(/^[0-9]+$/, 'Please enter a valid phone number')
    .required('Required'),
  // gender: Yup.string().required('Required'),
  howDidYou: Yup.string().required('Required'),
  reason: Yup.string()
    .min(20, 'Must betweeen 20 -  450 characters')
    .max(450, 'Must betweeen 20 -  450 characters')
    .required('Required')
});

export const CourseApplySchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Name is too short! Min characters: 2')
    .max(50, 'Name is too long! Max characters: 50')
    .required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
  phone: Yup.string()
    .min(10, 'Must be 10 digits. Eg. 9967025257')
    .max(10, 'Must be 10 digits. Eg. 9967025257')
    .matches(/^[0-9]+$/, 'Please enter a valid phone number')
    .required('Required'),
  // gender: Yup.string().required('Required'),
  howDidYou: Yup.string().required('Required'),
  reason: Yup.string()
    .min(20, 'Must betweeen 20 -  450 characters')
    .max(450, 'Must betweeen 20 -  450 characters')
    .required('Required')
});

export const ContactFormSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Name is too short! Min characters: 2')
    .max(50, 'Name is too long! Max characters: 50')
    .required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
  phone: Yup.string()
    .min(10, 'Must be 10 digits. Eg. 9967025257')
    .max(10, 'Must be 10 digits. Eg. 9967025257')
    .matches(/^[0-9]+$/, 'Please enter a valid phone number')
    .required('Required'),
  inquireAbout: Yup.string().required('Required'),
  message: Yup.string()
    .min(20, 'Must betweeen 20 -  450 characters')
    .max(450, 'Must betweeen 20 -  450 characters')
    .required('Required')
});

export const HiringFormSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Name is too short! Min characters: 2')
    .max(50, 'Name is too long! Max characters: 50')
    .required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
  phone: Yup.string()
    .min(10, 'Must be 10 digits. Eg. 9967025257')
    .max(10, 'Must be 10 digits. Eg. 9967025257')
    .matches(/^[0-9]+$/, 'Please enter a valid phone number')
    .required('Required'),
  company: Yup.string().required('Required!'),
  role: Yup.string().required('Required'),
  howDidYou: Yup.string().required('Required'),
  message: Yup.string()
    .min(20, 'Must betweeen 20 -  450 characters')
    .max(450, 'Must betweeen 20 -  450 characters')
    .required('Required')
});

export const InstructorMentorFormSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Name is too short! Min characters: 2')
    .max(50, 'Name is too long! Max characters: 50')
    .required('Required'),
  email: Yup.string().email('Invalid email').required('Required'),
  phone: Yup.string()
    .min(10, 'Must be 10 digits. Eg. 9967025257')
    .max(10, 'Must be 10 digits. Eg. 9967025257')
    .matches(/^[0-9]+$/, 'Please enter a valid phone number')
    .required('Required'),
  howDidYou: Yup.string().required('Required'),
  reason: Yup.string()
    .min(20, 'Must betweeen 20 -  450 characters')
    .max(450, 'Must betweeen 20 -  450 characters')
    .required('Required')
});
